import _ from "lodash";
import moment from "moment";
import React, { useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { sharedRequests } from "@/api/(requests)/shared";

import PostSessionSurveyQuestion from "./PostSessionSurveyQuestion";

const PostSessionSurvey = (props) => {
  const { callId, questionSet } = props;
  const [questions, setQuestions] = useState(_.get(questionSet, "questions", []));
  const pssStartedDateTime = moment().format("YYYY-MM-DDTHH:mm:ss");

  const handleEditChange = (e, index, key) => {
    let clonedQuestions = _.cloneDeep(questions);

    if (clonedQuestions[index][key] === parseInt(e.target.value)) {
      clonedQuestions[index][key] = undefined;
    } else {
      clonedQuestions[index][key] = parseInt(e.target.value);
    }
    setQuestions(clonedQuestions);
  };

  const submitHandler = async () => {
    const submissionQuestions = _.cloneDeep(questions);

    submissionQuestions["started_date_time"] = pssStartedDateTime;
    const data = {
      callId: callId,
      patientId: props.profile.username,
      post_session_survey: submissionQuestions,
    };

    await sharedRequests.post_ratings_v2({ data });
    props.submit();
  };

  const questionNotAnswered = (question) => question.answer == null;
  const disableSubmitButton = Object.values(questions).some(questionNotAnswered);

  const render = Object.keys(questions).map((questionKey, index) => {
    return (
      <PostSessionSurveyQuestion
        handleEditChange={handleEditChange}
        key={index}
        questionIndex={questionKey}
        surveyQuestion={questions[questionKey]}
      />
    );
  });

  return (
    <div className="container">
      <div className="survey-back-link-wpr mx-auto my-3 py-2">
        <h3 className="font-color-gray tw:font-bold">How would you rate today’s session?</h3>
        <p className="font-color-gray fs-14">
          We care about your progress and want to make sure you’re set up for success. Let us know
          how we’re doing by answering the questions below.
        </p>
        {render}
        <div className="d-flex justify-content-end mt-3">
          <Button2 disabled={disableSubmitButton} onPress={submitHandler}>
            Submit
          </Button2>
        </div>
      </div>
    </div>
  );
};

export default PostSessionSurvey;
